import { render } from "./ProjectCatalog.vue?vue&type=template&id=80bff7fa&ts=true&lang=pug"
import script from "./ProjectCatalog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCatalog.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__